import { IWorkspace } from '../interfaces/workspace.interface';
import { IDashbackResponse } from '../interfaces/responses.interface';
import { API } from './config-service.api';

export const getWorkspaces = () => API.get('/small-fleets/by-user');

export const createWorkspace = (
    data: any,
): Promise<IDashbackResponse<IWorkspace>> => API.post('/small-fleets/', data);

export const uploadWorkspaceLogo = (file: any) => {
    const formData = new FormData();
    formData.append('image', file);

    return API.post('/files/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const updateWorkspace = (id: string, data: any) => API.put(`/small-fleets/${id}`, data);
